import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

/** The server-side onboarding state (draft, organisation, vertical, done flags). */
export function useOnboardingDraft(businessId: string | undefined) {
  const trpc = useTRPC();
  return useQuery(
    trpc.onboarding.getDraft.queryOptions(
      { businessId: businessId ?? "" },
      { enabled: Boolean(businessId), staleTime: 30_000 },
    ),
  );
}
